import React from "react";

export default function CardList() {
  const cards = [
    {
      title: "Comprehensive manpower sourcing and management",
      description: "",
      image:
        "solutions/Tailored-Talent-Customized-Staffing-Services-for-Your-Unique-Needs.png",
    },
    {
      title:
        "Efficient manpower solutions for your logistics and warehouse needs",
      description: "",
      image: "solutions/Manpower-Planning.jpg",
    },
    {
      title: "Cost-effective service packages",
      description: "",
      image: "solutions/images.jpeg",
    },
    {
      title: "Advanced technology integration for efficient operations",
      description: "",
      image: "solutions/1695007571186.png",
    },
    {
      title: "Continuous employee training and skill development",
      description: "",
      image: "solutions/contin.jpeg",
    },
    {
      title: "24/7 customer support and problem resolution",
      description: "",
      image: "solutions/247-customer-support.jpg",
    },
    {
      title: "Flexible workforce scaling based on client needs",
      description: "",
      image: "solutions/BI_FLEXIBILITY_KOSSEK_SPOT.jpg",
    },
    {
      title: "Strict compliance with labor laws and regulations",
      description: "",
      image: "solutions/labourLaw.jpeg",
    },
  ];

  return (
    <div className="my-40">
      <div className="text-center mx-20 my-8 text-4xl font-bold tracking-wide uppercase bg-gradient-to-r from-pink-500 via-purple-500 to-indigo-500 text-transparent bg-clip-text">
        OFFERING SOLUTIONS
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 p-6 bg-gray-100">
        {cards.map((card, index) => (
          <div
            key={index}
            className="bg-white shadow-lg rounded-lg overflow-hidden hover:shadow-2xl transition-shadow"
          >
            <img
              src={card.image}
              alt={card.title}
              className="w-full h-48 object-cover"
            />
            <div className="p-4">
              <h3 className="text-xl font-bold font-poppins text-gray-800">
                {card.title}
              </h3>
              <p className="text-gray-600  mt-2">{card.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
